export default "__VITE_ASSET__CJu9IaDM__"